/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteVideoEditorEditsEditMutationResponse, DeleteVideoEditorEditsEditPathParams } from "../models/DeleteVideoEditorEditsEdit";

export function getDeleteVideoEditorEditsEditUrl(id: DeleteVideoEditorEditsEditPathParams["id"]) {
  const res = { method: 'DELETE', url: `/video-editor/edits/${id}` as const }
  return res
}

/**
 * @summary Delete an edit
 * {@link /video-editor/edits/:id}
 */
export async function deleteVideoEditorEditsEdit(id: DeleteVideoEditorEditsEditPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDeleteVideoEditorEditsEditUrl(id).url.toString(), ... requestConfig })
  return res.data
}